import './index.scss'

jQuery(($) => {

    const BREAKPOINT = 992
    const OPTIONS = {
        items : 2,
        nav : false,
        dotsData : false,
        loop :  false,
        mouseDrag: true,
        touchDrag: true,
        responsive : {
            0 : {
                items : 2,
                loop :  false,
                margin: 12,
                stagePadding : 24,
            },
            576 : {
                items : 2,
                loop :  false,
                margin: 12,
                stagePadding : 10,
            },
            768 : {
                items : 3,
                loop :  false,
                nav : true,
                margin: 12,
                stagePadding : 0
            },
            968 : {
                items : 3,
                loop :  false,
                nav : true,
                margin: 16,
                stagePadding : 0
            }
        }
    }

    const CAROUSELS = $('.carousel--industries');
    
    function initiateCarousels($carousel) {
        $carousel.owlCarousel(OPTIONS);
    }

    function destroyCarousels($carousel) {
        if ($carousel.hasClass('owl-loaded')) {
            $carousel
                .trigger('destroy.owl.carousel')
                .removeClass('owl-carousel owl-loaded')
                .find('.owl-stage-outer').children().unwrap()
        }
    }

    function handleServiceSpotlightCarousel() {
        let windowWidth = $(window).width()
        
        CAROUSELS.each((index, element) => {
            let $carousel = $(element)

            if (windowWidth <= BREAKPOINT) {
                //if (!$carousel.hasClass('owl-loaded')) {
                    initiateCarousels($carousel)
                //}
            } else {
                destroyCarousels($carousel);
            }
        })
    }
    
    handleServiceSpotlightCarousel();
    
    $(window).on('resize', function() {
        handleServiceSpotlightCarousel();
    })
});